import React from 'react';
import type ScreensPageType from '@atlassian/jira-admin-pages-screens-page/src/index.tsx';
import { markAsProductBundleReady } from '@atlassian/jira-spa/src/services/mark-as-product-bundle-ready/index.tsx';
import { LazyPage } from '@atlassian/jira-spa/src/view/lazy-page/index.tsx';
import { lazyForPaint } from '@atlassian/react-loosely-lazy';

export const LazyScreensPage = lazyForPaint<typeof ScreensPageType>(() =>
	markAsProductBundleReady(
		import(
			/* webpackChunkName: "async-jira-admin-pages-screens-page", jiraSpaEntry: "async-jira-admin-pages-screens-page" */ '@atlassian/jira-admin-pages-screens-page'
		),
	),
);

// eslint-disable-next-line jira/import/no-anonymous-default-export
export default () => (
	<LazyPage Page={LazyScreensPage} pageId="jira-admin-pages-screens-page" shouldShowSpinner />
);
